import { render } from "./TheCat.vue?vue&type=template&id=52b3d3f7&scoped=true&ts=true"
import script from "./TheCat.vue?vue&type=script&lang=ts"
export * from "./TheCat.vue?vue&type=script&lang=ts"

import "./TheCat.vue?vue&type=style&index=0&id=52b3d3f7&scoped=true&lang=css"

import exportComponent from "/vercel/path1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b3d3f7"]])

export default __exports__